import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { options, references } from '@apexdesigner/schema-tools';

export const activityMapping = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    designUuid: z
      .string()
      .describe('The process design lineage this mapping applies to'),

    sourceActivityId: z
      .string()
      .describe('Activity the token currently sits on'),

    action: options([
      {
        value: 'Move',
        name: 'Move',
        description: 'Move tokens to the target activity',
      },
      {
        value: 'Cancel',
        name: 'Cancel',
        description: 'Cancel tokens on the source activity',
      },
      {
        value: 'Add',
        name: 'Add',
        description:
          'Also create a new token on the target activity when a token sits on the source activity',
      },
    ]).describe('What happens to covered tokens'),

    targetActivityId: z
      .string()
      .nullable()
      .optional()
      .describe('Destination activity for Move and Add actions'),

    minSourceVersion: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Lowest source version this mapping applies to (open-ended when omitted)',
      ),

    maxSourceVersion: z
      .number()
      .nullable()
      .optional()
      .describe(
        'Highest source version this mapping applies to (open-ended when omitted)',
      ),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    tenant: references('Tenant'),
  })
  .describe(
    'A persistent migration rule for tokens on an activity that no longer\nexists in newer process design versions: move them to a target\nactivity, cancel them, or additionally create a new token on a\ntarget activity',
  )
  .as('ActivityMapping');

export { activityMapping as activityMappingSchema };
